import React from 'react';

import {
  AgeAttributeCard,
  GenderAttributeCard,
  TemperatureAttributeCard,
  LivenessAttributeCard,
  DeepfakeAttributeCard,
  UpperBodyAttributeCard,
  LowerBodyAttributeCard,
  HeadwearAttributeCard,
  BackpackAttributeCard,
} from '@vlabs/monokit/shared/ui/atribute-cards';
import { MapCell } from '@vlabs/shared/components/map-cell/MapCell';
import { selectIsAppFeatureAvailable } from '@vlabs/shared/selectors/appSelectors';
import { useWindowSize } from '@vlabs/uikit';
import { connect } from 'react-redux';

import st from './AttributesCell.module.sass';

function AttributesCellComponent({
  original,
  isLivenessAvailable,
  isDeepfakeAvailable,
  includedAttributes,
}) {
  const windowSize = useWindowSize();
  const size = windowSize.width < 1920 ? 'medium' : 'large';

  const {
    gender, age, upper_body, lower_body, accessories, user_data, liveness, deepfake,
    body_basic_attributes,
  } = original;

  let temperature;
  try {
    const parsed = user_data ? JSON.parse(user_data) : null;
    temperature = parsed?.t?.toFixed(1);
  } catch {
    temperature = undefined;
  }

  const isBodyBasicAttributesExist = body_basic_attributes !== null;
  const isFaceBasicAttributesExist = gender
    || (age !== null && age !== undefined);
  const isFaceAttributesExist = isFaceBasicAttributesExist
    || temperature
    || (liveness !== null && liveness !== undefined)
    || (deepfake !== null && deepfake !== undefined);

  // FIXME: 3 card skipped (emotion/mask/shoes)

  const attributes = {
    gender: gender !== undefined && (
      <GenderAttributeCard
        gender={gender}
        size={size}
      />
    ),
    age: age !== null && age !== undefined && (
      <AgeAttributeCard
        age={age}
        size={size}
      />
    ),
    temperature: temperature && (
      <TemperatureAttributeCard
        size={size}
        temperature={temperature}
      />
    ),
    liveness: isLivenessAvailable && (
      <LivenessAttributeCard
        liveness={liveness}
        size={size}
      />
    ),
    deepfake: isDeepfakeAvailable && (
      <DeepfakeAttributeCard
        deepfake={deepfake}
        size={size}
      />
    ),
    apparentGender: body_basic_attributes?.apparent_gender !== undefined
      && (
        <GenderAttributeCard
          gender={body_basic_attributes.apparent_gender}
          size={size}
        />
      ),
    apparentAge: body_basic_attributes?.apparent_age !== null && body_basic_attributes?.apparent_age !== undefined
      && (
        <AgeAttributeCard
          age={body_basic_attributes.apparent_age}
          size={size}
        />
      ),
    upperBody: upper_body && (
      <UpperBodyAttributeCard
        size={size}
        values={upper_body}
      />
    ),
    lowerBody: lower_body && (
      <LowerBodyAttributeCard
        size={size}
        values={lower_body}
      />
    ),
    headwear: upper_body?.headwear
      && (
        <HeadwearAttributeCard
          color={upper_body.headwear.apparent_color}
          headwear={upper_body.headwear.state}
          size={size}
        />
      ),
    backpack: accessories?.backpack && (
      <BackpackAttributeCard
        backpack={accessories.backpack.state}
        size={size}
      />
    ),
    map: <MapCell
      original={original}
      size={size}
    />,
  };

  const renderAttributes = (keys) => keys
    .filter((key) => includedAttributes.includes(key))
    .map((key) => attributes[key]);

  return (
    <div className={st.Root}>
      <div className={st.Attributes}>
        <div className={st.Attributes}>
          {!!isFaceAttributesExist && renderAttributes(['gender', 'age', 'temperature', 'liveness', 'deepfake'])}
          {!!isBodyBasicAttributesExist && !isFaceBasicAttributesExist && renderAttributes(['apparentGender', 'apparentAge'])}
        </div>
        {renderAttributes(['map'])}
      </div>
      <div className={st.Attributes}>{renderAttributes(['upperBody', 'lowerBody', 'headwear', 'backpack'])}</div>
    </div>
  );
}

export const AttributesCell = connect((state) => ({
  isLivenessAvailable: selectIsAppFeatureAvailable(state, 'estimations.liveness'),
  isDeepfakeAvailable: selectIsAppFeatureAvailable(state, 'estimations.deepfake'),
}))(AttributesCellComponent);
